<script setup lang="ts">
import { t } from '@storefront-satch/lib/translations'
</script>

<template>
  <div class="flex w-full flex-col pl-[61px] lg:pl-[52px]">
    <p class="font-sans text-sm text-black">
      {{ t('noResults.DEFAULT') }}
    </p>
  </div>
</template>
